module.exports = __webpack_public_path__ + "img/bg_topic_replace.7a95e352.png";